import React, { useState, useEffect } from "react";
import { Bar } from "@ant-design/charts";

const useResponsiveSize = () => {
  const [deviceType, setDeviceType] = useState("desktop");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) setDeviceType("mobile");
      else if (width <= 1024) setDeviceType("tablet");
      else setDeviceType("desktop");
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return deviceType;
};

const BarChart = (props) => {
  const { title, data, isGroup } = props;
  const deviceType = useResponsiveSize();

  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="chart-container">
        <h3 className="chart-title">{title}</h3>
        <p>No data available</p>
      </div>
    );
  }

  const colorTheme = isGroup
    ? ["#faad14", "#52c41a", "#1890ff"]
    : ["#faad14", "#52c41a"];

  // Get responsive configuration
  const getConfig = () => {
    const isMobile = deviceType === "mobile";
    const isTablet = deviceType === "tablet";

    const baseConfig = {
      data,
      seriesField: "type",
      color: colorTheme,
      tooltip: { visible: true, shared: true },
      animation: { appear: { animation: "wave-in", duration: 1000 } },
    };

    // Mobile: Vertical bars with wider columns
    if (isMobile) {
      return {
        ...baseConfig,
        xField: "value",
        yField: "category",
        isGroup: true,
        height: 350,
        barSize: 24, // Thinner bars
        padding: 8, // Reduced padding
        legend: { position: "top" },
        label: {
          position: "middle",
          style: { fill: "#fff", fontSize: 11 },
          formatter: (v) => `${v.value}%`,
        },
        yAxis: {
          label: {
            style: { fontSize: 11 },
            formatter: (text) =>
              text.length > 25 ? `${text.substring(0, 25)}...` : text,
          },
        },
      };
    }
    // Tablet: Horizontal bars with adjusted padding
    else if (isTablet) {
      return {
        ...baseConfig,
        xField: "value",
        yField: "category",
        isGroup: true,
        height: 350,
        barSize: 24, // Thinner bars
        padding: 8, // Reduced padding
        legend: { position: "top" },
        label: {
          position: "middle",
          style: { fill: "#fff", fontSize: 11 },
          formatter: (v) => `${v.value}%`,
        },
        yAxis: {
          label: {
            style: { fontSize: 11 },
            formatter: (text) =>
              text.length > 25 ? `${text.substring(0, 25)}...` : text,
          },
        },
      };
    }
    // Desktop: Original layout
    else {
      return {
        ...baseConfig,
        xField: "value",
        yField: "category",
        isGroup: true,
        height: 250,
        legend: { position: "top-left" },
        label: {
          position: "middle",
          style: { fill: "#fff", fontSize: 8 },
        },
      };
    }
  };

  const config = getConfig();

  return (
    <div className={`chart-container ${deviceType}`}>
      <h3 className="chart-title">{title}</h3>
      <Bar {...config} />
    </div>
  );
};

export default BarChart;
